'use client';

import {
  Camera,
  CaretLeft,
  ClockCounterClockwise,
  CubeFocus,
  GearSix,
  Lightning,
  MapPinArea,
} from '@phosphor-icons/react/dist/ssr';
import {
  EnterFullScreenIcon,
  ExitFullScreenIcon,
  HomeIcon,
  SpeakerLoudIcon,
} from '@radix-ui/react-icons';
import {
  Bot,
  BotMessageSquare,
  CarFront,
  Check,
  Cpu,
  Database,
  Disc,
  Dock,
  FileUp,
  Flag,
  Focus,
  Gamepad2,
  Gauge,
  MapIcon,
  Mountain,
  Pencil,
  Play,
  Plus,
  Radio,
  RadioTower,
  Rotate3D,
  RotateCcw,
  Route,
  Share,
  Share2,
  Sparkles,
  SquareKanban,
  Sun,
  Trash,
  TriangleAlert,
  X,
} from 'lucide-react';

import Battery0Icon from './components/Battery0Icon';
import Battery20Icon from './components/Battery20Icon';
import Battery40Icon from './components/Battery40Icon';
import Battery60Icon from './components/Battery60Icon';
import Battery80Icon from './components/Battery80Icon';
import Battery100Icon from './components/Battery100Icon';
import CameraFrontIcon from './components/CameraFrontIcon';
import InfraredIcon from './components/InfraredIcon';
import PayloadIcon from './components/PayloadIcon';
import PendingActionsIcon from './components/PendingActionsIcon';
import RemoveDoneIcon from './components/RemoveDoneIcon';
import RobotArmIcon from './components/RobotArmIcon';
import ScanIcon from './components/ScanIcon';
import WalkIcon from './components/WalkIcon';

const iconsList = {
  overview: SquareKanban,
  mission: Flag,
  mission_template: Mountain,
  history_mission: ClockCounterClockwise,
  live: Radio,
  manual_controller: Gamepad2,
  payload: PayloadIcon,
  arrow_left: CaretLeft,
  plus: Plus,
  signal: RadioTower,
  battery_0: Battery0Icon,
  battery_20: Battery20Icon,
  battery_40: Battery40Icon,
  battery_60: Battery60Icon,
  battery_80: Battery80Icon,
  battery_100: Battery100Icon,
  bolt: Lightning,
  robot_arm: RobotArmIcon,
  home: HomeIcon,
  rotate_left: RotateCcw,
  camera: Camera,
  camera_front: CameraFrontIcon,
  scan: ScanIcon,
  robot_head: Bot,
  bulb: Sun,
  fullscreen: EnterFullScreenIcon,
  fullscreen_exit: ExitFullScreenIcon,
  close: X,
  done: Check,
  remove_done: RemoveDoneIcon,
  share: Share2,
  export: Share,
  walk: WalkIcon,
  map_3d: CubeFocus,
  recording: Disc,
  recenter: Focus,
  speed_gauge: Gauge,
  route: Route,
  upload: FileUp,
  play_arrow: Play,
  chip: Cpu,
  delete: Trash,
  infrared: InfraredIcon,
  edit: Pencil,
  car: CarFront,
  pending_actions: PendingActionsIcon,
  warning: TriangleAlert,
  database: Database,
  gear: GearSix,
  volume_high: SpeakerLoudIcon,
  site: MapPinArea,
  geo_map: MapIcon,
  rotate_3d: Rotate3D,
  dock: Dock,
  ai_copilot: BotMessageSquare,
};

export default iconsList;
